/**
 * The Answer Document, as the client reads it.
 *
 * Deliberately NOT a whitelist rebuild: the fence parsers rebuilt every spec
 * key by key and silently dropped `unit` twice. This validates shape and
 * returns the object with every key the server sent. A block the client does
 * not recognise is kept and rendered as a notice, never dropped.
 */
export const BLOCK_KINDS = Object.freeze(['kpis', 'chart', 'table', 'text', 'findings', 'actions', 'caveat']);

export function parseAnswerDocument(input) {
  const a = typeof input === 'string' ? safeJson(input) : input;
  if (!a || typeof a !== 'object') return null;
  if (!a.headline || typeof a.headline.text !== 'string') return null;
  if (!Array.isArray(a.blocks)) return null;
  return {
    ...a,
    blocks: a.blocks.filter((b) => b && typeof b === 'object' && typeof b.kind === 'string'),
    claims: Array.isArray(a.claims) ? a.claims : [],
    entities: Array.isArray(a.entities) ? a.entities : [],
    meta: a.meta && typeof a.meta === 'object' ? a.meta : {},
  };
}

/** The keys a block must keep through parsing — the contract the round-trip test pins. */
export const BLOCK_REQUIRED_KEYS = Object.freeze({
  kpis: ['items', 'source'],
  chart: ['spec', 'source'],
  table: ['columns', 'rows', 'title', 'source', 'page_size'],
  text: ['markdown', 'citations'],
  findings: ['items'],
  actions: ['items'],
  caveat: ['text'],
});

function safeJson(s) { try { return JSON.parse(s); } catch { return null; } }
